const Header = ({ firstName, lastName, social }) => {
  const { facebook, twitter, github, linkedin, instagram } = social;
  return (
    <div>
      <header
        id="home"
        className="header particles-demo cover-bg"
        data-image-src="img/main-img.jpg"
        data-overlay="7"
      >
        <div id="particles-js"></div>
        <div className="container h-100">
          <div className="row align-items-center h-100">
            <div className="col-12 caption">
              <h6>Hello</h6>
              <h2>
                I Am {firstName} {lastName}
              </h2>
              <h4>
                <span>developer</span>
                <span>freelancer</span>
              </h4>
              <br />

              <div className="scoial-icon mt-20">
                {facebook && (
                  <a href={facebook} target="_blank">
                    <span>
                      <i className="fab fa-facebook-f"></i>
                    </span>
                  </a>
                )}
                {twitter && (
                  <a href={twitter} target="_blank">
                    <span>
                      <i className="fab fa-twitter"></i>
                    </span>
                  </a>
                )}
                {github && (
                  <a href={github} target="_blank">
                    <span>
                      <i className="fab fa-github"></i>
                    </span>
                  </a>
                )}
                {linkedin && (
                  <a href={linkedin} target="_blank">
                    <span>
                      <i className="fab fa-linkedin-in"></i>
                    </span>
                  </a>
                )}
                {instagram && (
                  <a href={instagram} target="_blank">
                    <span>
                      <i className="fab fa-instagram"></i>
                    </span>
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
};

export default Header;
